import { IBlock } from "../../framework/src/IBlock";
import { Message } from "../../framework/src/Message";
import { BlockComponent } from "../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../framework/src/RunEngine";
import { changeLogo, contactLogo, logoutLogo, shieldLogo, techHelp, termsLogo, userLogo } from "../../blocks/customisableuserprofiles2/src/assets";

// Customizable Area Start
import { getStorageData, setStorageData } from "../../framework/src/Utilities";
import { QuickBlox } from "quickblox/quickblox"
import moment from "moment";
import React from "react";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  showStudy: boolean;
  showButtonChats?: boolean;
  showButtonNotification?: boolean;
  unreadCount?: any;
  handleLanguageSwitch?: any
  language?: string
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  detail: any
  open: boolean,
  passwordDialogOpen: boolean;
  editProfile: boolean;
  expanded: any;
  termsDialogOpen: boolean;
  privacyDialogOpen: boolean;
  techBarOpen: boolean;
  contactBarOpen: boolean;
  requestAdmin: boolean;
  oldPassword: any,
  newPassword: any,
  newConfirmPassword: any,
  oldPasswordError: any,
  newPasswordError: any,
  newConfirmPasswordError: any,
  newPasswordSuccess: boolean;
  snackBar:boolean;
  oldEmailAddress: any,
  newEmailAddress: any,
  newConfirmEmailAddress: any,
  oldEmailAddressError: any,
  newEmailAddressError: any,
  newConfirmEmailAddressError: any,
  addressLine1: string,
  addressLine2: string,
  addressLine3: string,
  phoneNumber: any,
  phoneNumberError: any,
  fullName: any,
  fullNameError: any
  userEmail: any,
  userEmailError: any,
  contactFullName: any,
  contactFullNameError: any,
  contactUserEmail: any,
  contactUserEmailError: any,
  selectedReason: any,
  selectError: any,
  contactUserMessage: any,
  userDetails: any,
  termsAndConditions: any,
  privacyPolicy: any,
  technicalHelpData: any,
  showOldPassword: boolean,
  showNewPassword: boolean,
  showNewConfirmPassword: boolean,
  stdInput: any,
  studyData: any,
  searchQuery: any,
  selectedStudy: any,
  studyDrawerOpen: boolean,
  profileImage: string,
  profileImageForApi: File | null;
  profileImageError: string,
  selectedStudyName: any,
  logoutFlag: boolean,
  notificationDrawerFlag: boolean
  notificationResponce: any,
  showCheckbox: boolean,
  checkedValue: any,
  tokenExpired:boolean,
  tokenExpiredMessage: string,
  profileUpdateOpen: boolean,
  profileUpdateMessage: string,
  selectdPaper: boolean,
  selectedValue:string,
  showDiv:boolean,
  isRotated:boolean,
  // isPhoneNumberValid: boolean,
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class SideNavbarController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getUserProfileApiCallId: string = "";
  getTermsandConditionApiCallId: string = "";
  getPrivacyPolicyApiCallId: string = "";
  getFaqApiCallId: string = "";
  contactFormApiCallId: string = "";
  editUserProfileApiCallId: string = "";
  changePasswordApiCallId: string = "";
  changeEmailApiCallId: string = "";
  getStudyIndexApiCallId: string = "";
  getAllNotificationApiCallId: string = "";
  getNotificationDeleteApiCallID: string = "";
  putNotificationMarkASRead:string="";
  dropdownRef: React.RefObject<HTMLDivElement>;
  dropdownStudyRef: React.RefObject<HTMLDivElement>;
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);
    // Customizable Area Start
    this.dropdownRef = React.createRef();
    this.dropdownStudyRef = React.createRef();
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      // Customizable Area Start
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIRequestMessage)
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      detail: [{
        dName: 'Change Password',
        id: "change-password",
        dImg: changeLogo,
      },
      {
        dName: 'Terms and Conditions',
        id: "terms-condt",
        dImg: termsLogo
      },
      {
        dName: 'Privacy Policies',
        id: "privacy-policy",
        dImg: shieldLogo
      },
      {
        dName: 'Technical Help',
        id: "tech-help",
        dImg: techHelp
      },
      {
        dName: 'Contact Us',
        id: "contact-us",
        dImg: contactLogo
      },
      {
        dName: 'Logout',
        id: "logout",
        dImg: logoutLogo
      }
      ],
      open: false,
      passwordDialogOpen: false,
      editProfile: false,
      expanded: false,
      termsDialogOpen: false,
      privacyDialogOpen: false,
      techBarOpen: false,
      contactBarOpen: false,
      requestAdmin: false,
      oldPassword: "",
      newPassword: "",
      newConfirmPassword: "",
      oldPasswordError: "",
      newPasswordError: "",
      newConfirmPasswordError: "",
      newPasswordSuccess: false,
      snackBar:false,
      oldEmailAddress: '',
      newEmailAddress: '',
      newConfirmEmailAddress: '',
      oldEmailAddressError: '',
      newEmailAddressError: '',
      newConfirmEmailAddressError: '',
      addressLine1: '',
      addressLine2: '',
      addressLine3: '',
      phoneNumber: null,
      phoneNumberError: '',
      fullName: '',
      fullNameError: '',
      userEmail: '',
      userEmailError: '',
      contactFullName: '',
      contactFullNameError: '',
      contactUserEmail: "",
      contactUserEmailError: "",
      selectedReason: '',
      selectError: '',
      contactUserMessage: '',
      userDetails: null,
      termsAndConditions: null,
      privacyPolicy: null,
      technicalHelpData: null,
      showOldPassword: false,
      showNewPassword: false,
      showNewConfirmPassword: false,
      stdInput: '',
      studyDrawerOpen: false,
      selectedStudy: null,
      searchQuery: '',
      studyData: null,
      profileImage: '',
      profileImageError: '',
      selectedStudyName: "",
      logoutFlag: false,
      notificationDrawerFlag: false,
      notificationResponce: [],
      showCheckbox: false,
      checkedValue: [],
      tokenExpired:false,
      tokenExpiredMessage: "",
      profileUpdateOpen: false,
      profileUpdateMessage: "",
      selectdPaper: false,
      selectedValue: 'English',
      showDiv: true,
      isRotated: false,
      profileImageForApi: null,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Recived", message);
    // Customizable Area Start
    const handleRestApiResponse = (message: Message) => {
      if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
        const apiRequestCallId = message.getData(
          getName(MessageEnum.RestAPIResponceDataMessage)
        );

        const responseJson = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );

        if (apiRequestCallId != null && responseJson !== undefined) {
          switch (apiRequestCallId) {
            case this.getUserProfileApiCallId:
              this.callResponceOfProfile(responseJson)
              break;
            case this.getTermsandConditionApiCallId:
              this.setState({ termsAndConditions: responseJson.data.description });
              break;
            case this.getPrivacyPolicyApiCallId:
              this.setState({ privacyPolicy: responseJson.data.description });
              break;
            case this.getFaqApiCallId:
              this.setState({ technicalHelpData: responseJson.data });
              break;
            case this.editUserProfileApiCallId:
              this.editUserProfileResponse(responseJson)
              break;
            case this.getStudyIndexApiCallId:
              this.applyFreshStudyList(responseJson?.studies?.data);
              break;
            case this.getAllNotificationApiCallId:
              
              this.setState({ notificationResponce: responseJson.notifications })
              console.log(responseJson.notifications,'notificationResponcenotificationResponce');
              break;
            case this.getNotificationDeleteApiCallID:
              this.callDeleteResponce(responseJson)
              case this.putNotificationMarkASRead:
              this.callDeleteResponce(responseJson)
              break;
            case this.changeEmailApiCallId:
                this.SendRequestresponse(responseJson)             
              break;
            default:
          }
        }
      }
    };

    handleRestApiResponse(message)
    // Customizable Area End
  }

  // Customizable Area Start

  profileUpdateErrorMessage = (responseJson: any) => {
    const errors = responseJson?.errors;
    if (!errors) {
      return responseJson?.meta?.message || "Profile update failed";
    }
    if (typeof errors === "string") {
      return errors;
    }
    if (Array.isArray(errors)) {
      return errors.map((item) => String(item)).join(", ");
    }
    if (typeof errors === "object") {
      const parts = Object.entries(errors)
        .filter(([key]) => key !== "is_token_expired")
        .flatMap(([, value]: [string, any]) => (Array.isArray(value) ? value : [value]))
        .filter((value) => value != null && value !== "")
        .map((value) => String(value));
      if (parts.length) {
        return parts.join(", ");
      }
    }
    return responseJson?.meta?.message || "Profile update failed";
  };

  closeProfileUpdateMessage = () => {
    this.setState({ profileUpdateOpen: false, profileUpdateMessage: "" });
  };

  isSessionExpired = (responseJson: any) => {
    const flag = responseJson?.errors?.is_token_expired;
    return flag === true || String(flag).toLowerCase() === "true";
  };

  showSessionExpired = (responseJson: any) => {
    this.setState({
      tokenExpired: true,
      profileUpdateOpen: false,
      tokenExpiredMessage: responseJson?.errors?.message || "Your session has expired, please login again.",
    });
  };

  editUserProfileResponse = (responseJson: any) => {
    if (this.isSessionExpired(responseJson)) {
      this.showSessionExpired(responseJson);
      return;
    }

    if (responseJson?.errors) {
      const phoneError = responseJson.errors.full_phone_number;
      this.setState({
        phoneNumberError: Array.isArray(phoneError) ? phoneError[0] : phoneError || "",
        profileUpdateOpen: true,
        profileUpdateMessage: this.profileUpdateErrorMessage(responseJson),
      });
      return;
    }

    this.setState({
      editProfile: false,
      open: true,
      profileUpdateOpen: true,
      profileUpdateMessage: responseJson?.meta?.message || "Profile Updated Successfully",
    });
    this.getUserProfile();
  };
  
  
  async componentDidMount(): Promise<void> {
    this.getUserProfile()
    this.getStudyIndexDetail();
    this.callNotificationApi()

    let studyNameStore = await getStorageData("studyName")
    if (studyNameStore) {
      let parseData = JSON.parse(studyNameStore)
      this.setState({ selectedStudy: parseData?.id, selectedStudyName: parseData?.attributes?.study_name })
    }
    document.addEventListener("click", this.handleClickOutsideNav);
  }

  async componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutsideNav);
  }

  handleClickOutsideNav = (event: MouseEvent) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target as Node)) {
      this.setState({
        selectdPaper: false,
      })
    }
    if (this.dropdownStudyRef.current && !this.dropdownStudyRef.current.contains(event.target as Node)) {
      this.setState({
        studyDrawerOpen: false,
      })
    }
  }; 
  
  handleckedvalue = (id: any) => {
    return this.state.checkedValue.includes(id);
  };

  emailChangeErrorMessage = (res: any) => {
    if (!res || res.errors == null || res.errors === "") {
      return "";
    }
    if (typeof res.errors === "string") {
      return res.errors;
    }
    if (Array.isArray(res.errors)) {
      return res.errors.map((item:any) => String(item)).join(", ");
    }
    if (typeof res.errors === "object") {
      const first = Object.values(res.errors)[0];
      if (Array.isArray(first)) {
        return String(first[0] || "");
      }
      if (first != null) {
        return String(first);
      }
    }
    return "";
  };

  SendRequestresponse=(res:any)=>{
    const errorMessage = this.emailChangeErrorMessage(res);
    if (errorMessage) {
      this.setState({
        snackBar: false,
        newEmailAddressError: "",
        newConfirmEmailAddressError: errorMessage,
      });
      return;
    }
    this.setState({
      snackBar: true,
      oldEmailAddress: "",
      newEmailAddress: "",
      newConfirmEmailAddress: "",
      newEmailAddressError: "",
      newConfirmEmailAddressError: "",
    });
  }

handleCheckboxChange = (option: any, e: any) => {
  const { checked } = e.target;

  this.setState((prevState: any) => {
    let updated = [...prevState.checkedValue];

    if (checked) {
      updated.push(option.id);
    } else {
      updated = updated.filter((id: any) => id !== option.id);
    }

    return {
      checkedValue: updated,
    };
  });
};

  handleLanguageSelect = (language:string) => {
    this.setState(prevState => ({
      selectdPaper: !prevState.selectdPaper,
        selectedValue: language, 
        showDiv: true,         
        isRotated: false       
    }));
};
  handleClick = () => {
    this.setState((prevState) => ({
        isRotated: !prevState.isRotated,
        showDiv: !prevState.showDiv,
    }));
};
  selectedLanguage = () => {
    switch (this.props.language) {
      case 'en':
        return 'English';

      case 'fr':
        return 'French'

      case 'es':
        return 'Spanish'

      case 'de':
        return 'German'

      default:
        return 'English';
    }
  }

  handleSelectChange = (event: { target: { value: unknown } })=> {
    this.setState({ selectedValue: event.target.value as string });
  };
  handleLanguageSelected = () => {
    this.setState(prevState => ({
        selectdPaper: !prevState.selectdPaper,
        isRotated: !prevState.isRotated, 
    }));
};

  callDeleteResponce = (responseJson: any) => {
    this.setState({showCheckbox:false})
    this.callNotificationApi()
  }
  handleSelectAll() {
    const { notificationResponce, checkedValue } = this.state;
  
    if (checkedValue.length === notificationResponce.length) {
      this.setState({ checkedValue: [] }); // unselect all
    } else {
      const allIds = notificationResponce.map((item: any) => item.id);
      this.setState({ checkedValue: allIds }); // select all
    }
  }

  handleMarkAsRead = () => {
    let token = localStorage.getItem("token");
  
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
  
    const { checkedValue } = this.state;
  
    const idString = checkedValue.join(',');
  
    const httpBody = new FormData();
    httpBody.append("notification_ids[]", idString);
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.putNotificationMarkASRead = requestMessage.messageId;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getAllNotificationMarkAsReadApiEndPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      httpBody
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.putApiMethod
    );
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
    // ✅ FIXED optimistic update
    this.setState((prevState) => {
      const updatedNotifications = prevState.notificationResponce.map((notification: any) => {
        if (prevState.checkedValue.includes(notification.id)) {
          return { ...notification, is_read: true };
        }
        return notification;
      });
  
      return {
        notificationResponce: updatedNotifications,
        checkedValue: [] // clear selection
      };
    });
  };

  handleRemove = () => {
    let token = localStorage.getItem("token");
  
    const header = {
      "Content-Type": configJSON.dashboarContentType,
      "token": token
    };
  
    const { checkedValue } = this.state;
  
    const idString = checkedValue.join(',');
  
    const httpBody = new FormData();
    httpBody.append("notification_ids[]", idString);
  
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
  
    this.getNotificationDeleteApiCallID = requestMessage.messageId;
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getdeleteNotificationApiEndPoint
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      httpBody
    );
  
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.deleteAllAppointmentsAPiMethod
    );
  
    runEngine.sendMessage(requestMessage.id, requestMessage);
  
    // ✅ optional UI update (instant remove)
    this.setState((prevState) => ({
      notificationResponce: prevState.notificationResponce.filter(
        (item: any) => !prevState.checkedValue.includes(item.id)
      ),
      checkedValue: []
    }));
  };
  handleCloseDialog = () => {
    this.setState({ tokenExpired: false });
    const message = new Message(getName(MessageEnum.NavigationMessage));
    message.addData(getName(MessageEnum.NavigationTargetMessage), "EmailAccountLoginBlock");
    message.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(message);
  };
  redirectByNotification = (item: any) => {
    const { redirect_notification, redirect_id } = item;
    if (!redirect_notification) {
      return; 
    }
  
    switch (redirect_notification) {
      case "appointment":
        this.props.navigation.navigate("Appointments", {
          appointmentId: redirect_id, 
        });
        break;
  
      case "task_list":
        this.props.navigation.navigate("TaskList", {
          taskId: redirect_id,
        });
        break;
  
      // case "study":
      //   this.props.navigation.navigate("Study", {
      //     studyId: redirect_id,
      //   });
      //   break;
  
      case "community":
        this.props.navigation.navigate("CommunityForum");
        break;
  
      default:
        console.warn(
          "Unknown redirect_notification:",
          redirect_notification
        );
    }
  };
  
  handleCloseDialog2 =()=>{
    this.setState({ snackBar: false,requestAdmin:false,open:true});
  }
  callResponceOfProfile = (responseJson: any) => {
    let addressBreakdown = "";
    if (this.isSessionExpired(responseJson)) {
      this.showSessionExpired(responseJson);
      return;
    }
    if (responseJson.data.attributes?.address) {
      let address = responseJson.data.attributes?.address; // Example string with extra comma at the end
      address = address.trim().replace(/,\s*$/, ''); // Remove extra comma at the end
      addressBreakdown = address.split(',');
    }
    this.setState({
      userDetails: responseJson.data.attributes,
      fullName: responseJson.data.attributes.full_name,
      userEmail: responseJson.data.attributes.email,
      phoneNumber: responseJson.data.attributes.full_phone_number,
      profileImage: responseJson.data.attributes.profile_image,
      addressLine1: addressBreakdown[0],
      addressLine2: addressBreakdown[1],
      addressLine3: addressBreakdown[2]
    })
    localStorage.setItem("quickBloxId", responseJson.data.attributes.quickblox_id)
    localStorage.setItem("user_name", responseJson.data.attributes.full_name)

  }
  handleDrawerOpen = () => {
    this.setState({
      open: true, notificationDrawerFlag: false
    });
  };
  handleNotificationDrawer = () => {
    this.setState({ notificationDrawerFlag: true, open: false })
    this.callNotificationApi()
  }
  callNotificationApi = () => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getAllNotificationApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getAllNotificationApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  handleNotificationDrawerClose = () => {
    this.setState({
      notificationDrawerFlag: false
    })
  }
  callFormattedDate = (date: string) => {
    const dynamicDate = moment.utc(date);
    const currentDate = moment.utc();

    if (dynamicDate.isSame(currentDate, "day")) {
      return dynamicDate.format("[Today at] h:mm A");
    }
    return dynamicDate.format("MMMM Do, YYYY [at] h:mm A");
  };
  
  handleDrawerClose = () => {
    this.setState({
      open: false,
      editProfile: false,
      contactBarOpen: false,
      studyDrawerOpen: false,
      fullNameError: '',
      userEmailError: '',
      phoneNumberError: '',
      contactFullName: '',
      contactFullNameError: '',
      contactUserEmail: "",
      contactUserEmailError: "",
      selectedReason: '',
      selectError: '',
      techBarOpen: false
    });
  };

  handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };

  handleClickOpen = (name: string) => {
    switch (name) {
      case 'Change Password':
        this.setState({ passwordDialogOpen: true, open: false });
        break;
      case 'Request Email Change':
        this.setState({ requestAdmin: true, open: false,oldEmailAddress:this.state.userEmail });
        break;
      case 'Terms and Conditions':
        this.setState({ termsDialogOpen: true, open: false });
        this.getTermsAndCondition();
        break;
      case 'Privacy Policies':
        this.setState({ privacyDialogOpen: true, open: false });
        this.getPrivacyPolicy();
        break;
      case 'Technical Help':
        this.setState({ techBarOpen: true });
        this.getFaqs();
        break;
      case 'Contact Us':
        this.setState({ contactBarOpen: true });
        break;
      case 'Logout':
        this.setState({ logoutFlag: true })

        break;
      default:
        break;
    }
  };

  handleClose = (name: string) => {
    switch (name) {
      case 'Change Password':
        this.setState({
          passwordDialogOpen: false, open: true,
          oldPassword: "", newPassword: "", newConfirmPassword: "",
          oldPasswordError: '', newPasswordError: '', newConfirmPasswordError: '',
          showOldPassword: false,
          showNewPassword: false,
          showNewConfirmPassword: false,
        });
        break;
      case 'Request Email Change':
        this.setState({
          requestAdmin: false, open: true,
          oldEmailAddress: '', newEmailAddress: '', newConfirmEmailAddress: '',
          oldEmailAddressError: '', newEmailAddressError: '', newConfirmEmailAddressError: '',
          fullNameError: '', userEmailError: '', phoneNumberError: ''
        });
        break;
      case 'Terms and Conditions':
        this.setState({ termsDialogOpen: false, open: true });
        break;
      case 'Privacy Policies':
        this.setState({ privacyDialogOpen: false, open: true });
        break;
      case 'Technical Help':
        this.setState({ techBarOpen: false, open: true });
        break;
      case 'Contact Us':
        this.setState({
          contactBarOpen: false, open: true, contactFullName: '',
          contactFullNameError: '',
          contactUserEmail: "",
          contactUserEmailError: "",
          selectedReason: '',
          selectError: '',
          contactUserMessage: '',
        });
        break;
      default:
        break;

    }
  }

  handleLogout = () => {
    localStorage.clear();
    this.props.navigation.navigate('EmailAccountLoginBlock')
  }

  handleOldPasswordChange = (value: any) => {
    const strongPasswordRegex = configJSON.passwordRegex;
    let oldPasswordError = '';
    if (value !== '') {
      oldPasswordError = strongPasswordRegex.test(value) ? '' : 'Old password is invalid!';
    }
    this.setState({
      oldPassword: value,
      oldPasswordError: oldPasswordError
    });
  }

  handleNewPasswordChange = (value: any) => {
    const strongPasswordRegex = configJSON.passwordRegex;
    let newPasswordError = '';
    if (value !== '') {
      newPasswordError = strongPasswordRegex.test(value)
        ? ''
        : 'Password must contain 1 Uppercase, 1 Lowercase, 1 Special and 1 Numeric Characters!';
    }
    this.setState({
      newPassword: value,
      newPasswordError: newPasswordError,
      newConfirmPasswordError: value === this.state.newConfirmPassword ? '' : this.state.newConfirmPasswordError,
    });

  }

  handleNewConfirmPasswordChange = (value: any) => {
    this.setState({
      newConfirmPassword: value,
      newConfirmPasswordError: this.state.newPassword === value ? '' : 'Password do not match',
    });
  }
  /* istanbul ignore next */
  newSubmitPassWord = async () => {
    const currentPassword = await getStorageData("currentPassword")

    if (this.state.oldPassword === "") {
      this.setState({ oldPasswordError: "please enter old password" })
      return
    }

    if (this.state.newPassword === "") {
      this.setState({ newPasswordError: "please enter password" })
      return
    }

    if (this.state.newConfirmPassword === "") {
      this.setState({ newConfirmPasswordError: "please enter confirm password" })
      return
    }

    if (this.state.newPassword !== this.state.newConfirmPassword) {
      this.setState({ newConfirmPasswordError: "Password do not match" })
      return
    }

    if (this.state.oldPassword !== currentPassword) {
      this.setState({ oldPasswordError: "Your input does not match to your old/current password" })
      return
    }

    this.changePassword({ current_password: this.state.oldPassword, new_password: this.state.newPassword })
    await setStorageData("currentPassword", this.state.newPassword)
    this.setState({ open: true, passwordDialogOpen: false, oldPassword: "", newPassword: "", newConfirmPassword: "" });
    return
  }

  handleOldEmailAddress = (value: any) => {
    const strongEmailRegex = configJSON.emailRegex;
    this.setState({
      oldEmailAddress: value,
      oldEmailAddressError: strongEmailRegex.test(value)
        ? ""
        : "Old Email is invalid!"
    })
  }

  handleNewEmailAddress = (value: any) => {
    const strongEmailRegex = configJSON.emailRegex;
    this.setState({
      newEmailAddress: value,
      newEmailAddressError: strongEmailRegex.test(value)
        ? ""
        : "Email must be valid!"
    })
  }
  handleEmailChange =(value:any)=>{       
        if(this.state.userEmail===value.target.value){
          this.setState({newEmailAddressError:'New Email must be different from current Email. '})
        }
  }
  handleNewConfirmEmailAddress = (value: any) => {
    this.setState({
      newConfirmEmailAddress: value,
      newConfirmEmailAddressError: this.state.newEmailAddress === value ? "" : 'Email does not match!'
    })
  }

  newSubmitEmailAddress = () => {
    if (this.state.oldEmailAddress === "") {
      this.setState({ oldEmailAddressError: 'please enter your old email' })
      return
    }

    if (this.state.newEmailAddress === "") {
      this.setState({ newEmailAddressError: 'please enter your new email' })
      return
    }

    if (this.state.newConfirmEmailAddress === "") {
      this.setState({ newConfirmEmailAddressError: 'please enter email confirmation' })
      return
    }

    if (this.state.newEmailAddress !== this.state.newConfirmEmailAddress) {
      this.setState({ newConfirmEmailAddressError: 'Email does not match!' })
      return
    }

    if (this.state.oldEmailAddress !== this.state.userEmail) {
      this.setState({ oldEmailAddressError: 'Your input does not match your current/old email' })
      return
    }

    if (this.state.oldEmailAddress === this.state.newEmailAddress) {     
      return
    }


    this.changeEmail({ current_email: this.state.oldEmailAddress, new_email: this.state.newEmailAddress.toLowerCase() })
   
    return
  }

  handleFullNameEdit = (event: any) => {
    const strongNameRegex = configJSON.nameRegex;
    const newFullName = event.target.value;
    const isLengthValid = newFullName.length > 2;

    this.setState({
      fullName: newFullName,
      fullNameError: strongNameRegex.test(newFullName) && isLengthValid
        ? ""
        : 'Please enter a valid full name'
    })
  }

  handleUserNewEmail = (event: any) => {
    const strongEmailRegex = configJSON.emailRegex;
    const newUserEmail = event.target.value;

    this.setState({
      userEmail: newUserEmail,
      userEmailError: strongEmailRegex.test(newUserEmail)
        ? ""
        : "Please enter a valid email"
    })
  }

  handlePhoneNumberChange = (event: any) => {
    const strongPhoneNumberRegex = configJSON.phoneNumberRegex;
    const newPhoneNumber = event.target.value;
  
    this.setState({
      phoneNumber: newPhoneNumber,
      phoneNumberError:
        newPhoneNumber && !strongPhoneNumberRegex.test(newPhoneNumber)
          ? 'Please enter a valid phone number'
          : ''
    });
  };
  

  handleContactFullName = (event: any) => {
    const strongNameRegex = configJSON.nameRegex;
    const newContactFullName = event.target.value;
    const isLengthValid = newContactFullName.length > 2;

    this.setState({
      contactFullName: newContactFullName,
      contactFullNameError: strongNameRegex.test(newContactFullName) && isLengthValid
        ? ""
        : 'Please enter a valid full name'
    })
  }

  handleContactUserEmail = (event: any) => {
    const strongEmailRegex = configJSON.emailRegex;
    const newContactUserEmail = event.target.value;

    this.setState({
      contactUserEmail: newContactUserEmail,
      contactUserEmailError: strongEmailRegex.test(newContactUserEmail)
        ? ""
        : "Please enter a valid email"
    })
  }

  handleDropdownChange = (event: any) => {
    const newSelectedReason = event.target.value;
    const isError = newSelectedReason === '';

    this.setState({
      selectedReason: newSelectedReason,
      selectError: isError ? "Please select a reason" : ""
    });
  };
  handleUpdateDetailsClick = () => {

    const { fullName, userEmail, phoneNumber, addressLine1, addressLine2, addressLine3 } = this.state;
    const isFullNameValid = configJSON.nameRegex.test(fullName) && fullName.length > 2;
    const isEmailValid = configJSON.emailRegex.test(userEmail);
    const isPhoneNumberValid = !phoneNumber || configJSON.phoneNumberRegex.test(phoneNumber);

    this.setState({
      fullNameError: isFullNameValid ? "" : 'Please enter a valid full name',
      userEmailError: isEmailValid ? "" : 'Please enter a valid email',
      phoneNumberError:
    phoneNumber && !isPhoneNumberValid
      ? 'Please enter a valid phone number'
      : ''
});

    if (isFullNameValid && isEmailValid && isPhoneNumberValid) {
      let address = ""
      if (addressLine1 && addressLine1.length > 0) {
        address = addressLine1
      }
      if (addressLine2 && addressLine2.length > 0) {
        address = address + ", " + addressLine2
      }
      if (addressLine3 && addressLine3.length > 0) {
        address = address + ", " + addressLine3
      }
      
      this.editUserProfile();
    }
  };
  /* istanbul ignore next */
  handleContactSubmitButton = () => {
    const { contactFullName, contactUserEmail, selectedReason, contactUserMessage } = this.state

    const isContactFullNameValid = configJSON.nameRegex.test(contactFullName) && contactFullName.length > 2;
    const isContactUserEmailValid = configJSON.emailRegex.test(contactUserEmail);
    const isReasonValid = selectedReason !== ''

    this.setState({
      contactFullNameError: isContactFullNameValid ? "" : 'Please enter a valid full name',
      contactUserEmailError: isContactUserEmailValid ? "" : 'Please enter a valid email',
      selectError: isReasonValid ? "" : 'Please select a reason',
    });

    if (isContactFullNameValid && isContactUserEmailValid && selectedReason) {
      this.contactForm({
        name: contactFullName,
        email: contactUserEmail,
        reason: selectedReason,
        message: contactUserMessage
      })
      this.setState({
        contactBarOpen: false, open: true, contactFullName: '', contactUserEmail: '', selectedReason: '', contactUserMessage: ''
      })
    }
  }

  getTermsAndCondition = () => {
    const header = {
      "Content-Type": configJSON.apiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getTermsandConditionApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getTermsAndConditionApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getPrivacyPolicy = () => {
    const header = {
      "Content-Type": configJSON.apiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getPrivacyPolicyApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getPrivacyPolicyApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getFaqs = () => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getFaqApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getFaqsApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getUserProfile = () => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getUserProfileApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getUserAccountApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  changePassword = ({ current_password, new_password }: { current_password: string, new_password: string }) => {
    let token = localStorage.getItem("token")
    const headers = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    }

    const httpBody = {
      data: {
        "current_password": current_password,
        "new_password": new_password
      }
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.changePasswordApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.changePasswordApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.putApiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  changeEmail = ({ current_email, new_email }: { current_email: string, new_email: string }) => {
    let token = localStorage.getItem("token")
    const headers = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    }

    const httpBody = {

      "old_email": current_email,
      "new_email": new_email

    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.changeEmailApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.changeEmailApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.postApiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  contactForm = (data: any) => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    };
    const httpBody = {
      "data": {
        "name": data.name,
        "email": data.email,
        "reason": data.reason,
        "message": data.message,
      }
    }

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getContactUsApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.postApiMethod
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    this.contactFormApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  editUserProfile = () => {
    let token = localStorage.getItem('token');
    const headers = {
      "token": token
    };
    const { fullName, phoneNumber,addressLine1, addressLine2, addressLine3} = this.state;
    let address = ""
    if (addressLine1 && addressLine1.length > 0) {
      address = addressLine1
    }
    if (addressLine2 && addressLine2.length > 0) {
      address = address + ", " + addressLine2
    }
    if (addressLine3 && addressLine3.length > 0) {
      address = address + ", " + addressLine3
    }
    const httpBody = new FormData();
    httpBody.append("full_name", fullName);
    if (phoneNumber === "") {
      httpBody.append("full_phone_number", null as any);
    }
    else if (phoneNumber && phoneNumber.trim() !== "") {
      httpBody.append("full_phone_number", phoneNumber);
    }
    httpBody.append("address", address);

    if (this.state.profileImageForApi) {
      httpBody.append("profile_image", this.state.profileImageForApi);
    }

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      httpBody
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.patchApiMethod
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.editUserProfileApiEnd
    );

    this.editUserProfileApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  applyFreshStudyList = async (studies: any) => {
    const list = Array.isArray(studies) ? studies : [];
    const stored = await getStorageData("studyName");
    let storedId = this.state.selectedStudy;

    if (stored) {
      try {
        storedId = JSON.parse(stored)?.id || storedId;
      } catch (error) {
        storedId = this.state.selectedStudy;
      }
    }

    const match = list.find((item: any) => String(item.id) === String(storedId));
    if (match) {
      setStorageData("studyName", JSON.stringify(match));
      setStorageData("studyId", match.id);
      this.setState({
        studyData: list,
        selectedStudy: match.id,
        selectedStudyName: match.attributes?.study_name,
      });
      return;
    }

    this.setState({ studyData: list });
  };

  getStudyIndexDetail = () => {
    let token = localStorage.getItem("token")
    const header = {
      "Content-Type": configJSON.apiContentType,
      "token": token
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getStudyApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    this.getStudyIndexApiCallId = requestMessage.messageId;

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }
  getFilteredStudies = () => {
    return this.state.studyData?.filter((item: {
      attributes: any; study_name: string;
    }) =>
      item.attributes.study_name.toLowerCase().includes(this.state.searchQuery.toLowerCase())
    );
  };

  handleSearchChange = (event: any) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleItemClick = (selectedStudy: any) => {
    this.setState({
      selectedStudy: selectedStudy.id,
      selectedStudyName: selectedStudy.attributes.study_name,
      studyDrawerOpen: false
    });
    setStorageData("studyName", JSON.stringify(selectedStudy));
    setStorageData("studyId", selectedStudy.id);
    window.dispatchEvent(new Event("studyChanged"));
    this.props.navigation.navigate('Dashboard'); 
  };

  handleStudyDrawerOpen = () => {
    this.setState({ studyDrawerOpen: !this.state.studyDrawerOpen });
  };
  handleClickShowOldPassword = () => {
    this.setState((prevState) => ({
      showOldPassword: !prevState.showOldPassword
    }))
  }
  handleClickShowNewPassword = () => {
    this.setState((prevState) => ({
      showNewPassword: !prevState.showNewPassword
    }))
  }
  handleClickShowNewConfirmPassword = () => {
    this.setState((prevState) => ({
      showNewConfirmPassword: !prevState.showNewConfirmPassword
    }))
  }

  onUpload = (file: File) => {
    this.setState({ profileImageError: '' });

    const extensionArray = file.name.split('.');
    const extension = extensionArray.pop();

    if (extension) {
      const lowerCaseExtension = extension.toLowerCase();

      if (lowerCaseExtension !== 'jpg' && lowerCaseExtension !== 'jpeg') {
        this.setState({ profileImageError: 'Please upload a valid image file as only JPEG and JPG files are allowed' });
        return
      }

      this.setState({ 
        profileImageForApi: file
      });      
    } else {
      this.setState({ profileImageError: 'Please upload a valid image file as only JPEG and JPG files are allowed' });
    }
  };

  imageShowSrc = () => {
    const { profileImageForApi, profileImage } = this.state;
    console.log("@@@profileImageForApi",profileImageForApi)
    if (profileImageForApi) {
      return URL.createObjectURL(profileImageForApi);
    } else if (profileImage) {
      return profileImage
    } else {
      return userLogo;
    }
  }

  handleRoute = (route: string) => {
    const routeTo = new Message(getName(MessageEnum.NavigationMessage));
    routeTo.addData(
      getName(MessageEnum.NavigationTargetMessage),
      route
    );
    routeTo.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(routeTo);
  }
  // Customizable Area End
}
